import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=3b377e4a&scoped=true&"
import script from "./OrganizationSettings.vue?vue&type=script&lang=ts&"
export * from "./OrganizationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b377e4a",
  null
  
)

export default component.exports